/*!
 * KoliBri - The accessible HTML-Standard
 */
import { a as __rest } from './tslib.es6-QNbPBOk5.js';
import { h } from './index-C_ZKddLG.js';
import { b as bem } from './bem-registry-3ondDImf.js';
import { c as clsx } from './clsx-COFh-Vc8.js';

const iconBem = bem.forBlock('kol-icon');
const BEM_CLASS_ICON = iconBem();
const BEM_CLASS_ICON__ICON = iconBem('icon');
const IconFC = (_a) => {
    var { class: classNames, icons, label } = _a, htmlAttributes = __rest(_a, ["class", "icons", "label"]);
    const hasAriaLabel = (label === null || label === void 0 ? void 0 : label.length) > 0;
    return (h("i", Object.assign({}, htmlAttributes, { "aria-hidden": hasAriaLabel ? undefined : 'true', "aria-label": hasAriaLabel ? label : undefined, class: clsx(BEM_CLASS_ICON, BEM_CLASS_ICON__ICON, icons, classNames), role: hasAriaLabel ? 'img' : 'presentation' })));
};

export { IconFC as I };
//# sourceMappingURL=component-BjVFpeYY.js.map

//# sourceMappingURL=component-BjVFpeYY.js.map